module.exports = __webpack_public_path__ + "static/media/education-object-2-3.56ed928e.png";